import {SnackBarAction, SnackBarMutation} from "./types";

export default {
    [SnackBarAction.SET]({commit}, {data, type}) {
        commit(SnackBarMutation.SET, {data, type});
        commit(SnackBarMutation.SET_ACTIVE, true);
    },
    [SnackBarAction.SET_ACTIVE]({commit}, active) {
        commit(SnackBarMutation.SET_ACTIVE, active);
    }
}